import { render, staticRenderFns } from "./ProductsAppBar.vue?vue&type=template&id=61d53bd1&scoped=true&"
import script from "./ProductsAppBar.vue?vue&type=script&lang=js&"
export * from "./ProductsAppBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAppBar.vue?vue&type=style&index=0&id=61d53bd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d53bd1",
  null
  
)

export default component.exports